(function () {
  var Stigma = {};

  // --- cookies ---
  function setCookie(k, v, days) {
    var d = new Date(); d.setTime(d.getTime() + days * 864e5);
    document.cookie = k + '=' + v + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  function getCookie(k) {
    return document.cookie.split('; ').reduce(function (a, c) {
      var p = c.split('='); return p[0] === k ? decodeURIComponent(p[1]) : a;
    }, '');
  }

  // --- age gate ---
  function ageConfirmed() {
    try { if (window.localStorage && localStorage.getItem('stigma_aged') === '1') return true; } catch (e) {}
    try { if (window.sessionStorage && sessionStorage.getItem('stigma_aged') === '1') return true; } catch (e) {}
    return getCookie('stigma_aged') === '1';
  }
  function rememberAge() {
    setCookie('stigma_aged', '1', 365);
    try { if (window.localStorage) localStorage.setItem('stigma_aged', '1'); } catch (e) {}
    try { if (window.sessionStorage) sessionStorage.setItem('stigma_aged', '1'); } catch (e) {}
  }
  function initAgeGate() {
    var gate = document.getElementById('StigmaAgeGate');
    if (!gate) return;
    if (ageConfirmed()) { gate.remove(); return; }
    document.body.classList.add('no-scroll');
    gate.hidden = false;
    var yes = gate.querySelector('[data-age-yes]');
    if (yes) yes.addEventListener('click', function () {
      rememberAge();
      document.body.classList.remove('no-scroll');
      gate.remove();
    });
  }

  // --- countdown ---
  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(target)) return;
      var units = el.querySelectorAll('[data-unit]');
      function tick() {
        var diff = Math.max(0, target - Date.now());
        var d = Math.floor(diff / 864e5); diff -= d * 864e5;
        var h = Math.floor(diff / 36e5); diff -= h * 36e5;
        var m = Math.floor(diff / 6e4); diff -= m * 6e4;
        var s = Math.floor(diff / 1e3);
        var vals = { days: d, hours: h, minutes: m, seconds: s };
        units.forEach(function (u) {
          var key = u.getAttribute('data-unit');
          var v = vals[key]; if (v == null) return;
          u.textContent = String(v).padStart(2, '0');
        });
      }
      tick(); setInterval(tick, 1000);
    });
  }

  // --- coupon copy ---
  function initCoupons() {
    document.querySelectorAll('[data-coupon]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-coupon');
        if (navigator.clipboard) navigator.clipboard.writeText(code);
        btn.setAttribute('data-copied', '1');
        setTimeout(function () { btn.removeAttribute('data-copied'); }, 1500);
      });
    });
  }

  // --- FAQ accordion ---
  function initFaq() {
    document.querySelectorAll('[data-faq]').forEach(function (item) {
      var q = item.querySelector('.faq-item__q');
      if (!q) return;
      var glyph = item.querySelector('.faq-item__glyph');
      q.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (glyph) glyph.textContent = open ? '−' : '+';
      });
    });
  }

  // --- PDP description "read more" ---
  // The clamp is applied by CSS, not here, so a long description never flashes
  // full height before this runs. All this does is decide whether the toggle is
  // needed at all (short copy doesn't need one) and drive the open state.
  function initPdpText() {
    document.querySelectorAll('[data-pdp-text]').forEach(function (wrap) {
      var body = wrap.querySelector('.pdp-text__body');
      var btn = wrap.querySelector('[data-pdp-text-toggle]');
      if (!body || !btn) return;
      var label = btn.querySelector('[data-pdp-text-label]');
      var more = label ? label.textContent : '';
      var less = btn.getAttribute('data-less-label') || 'Read less';

      // Overflow only exists while the clamp is on, so is-static has to come off
      // before measuring — otherwise the first "it fits" verdict is permanent and
      // the toggle never comes back when the copy reflows longer. Both class
      // writes happen in one task, so nothing paints in between.
      // Skipped entirely once open: expanded copy always "fits".
      function measure() {
        if (wrap.classList.contains('is-open')) return;
        wrap.classList.remove('is-static');
        var overflows = body.scrollHeight - body.clientHeight > 1;
        wrap.classList.toggle('is-static', !overflows);
      }
      measure();

      btn.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (label) label.textContent = open ? less : more;
      });

      // A narrower viewport reflows the copy into more lines, so text that fit
      // at desktop width can start overflowing at phone width. The webfont
      // swapping in changes the metrics for the same reason.
      window.addEventListener('resize', measure);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    });
  }

  // --- PDP gallery ---
  // The gallery used to be a hardcoded featured_image with a row of thumbnails
  // that were plain <div>s: no handler, no role, nothing to click. The main
  // image is now a snap track of one slide per media item (see .pdp-gallery in
  // stigma-base.css), so swiping, momentum and settling on a slide are the
  // browser's, and this only has to do the three things the browser cannot:
  // point the thumbnails at slides, keep the marked thumbnail in step with
  // whatever the track has scrolled to, and add mouse drag.
  function initPdpGallery() {
    var gallery = document.querySelector('[data-pdp-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-gallery-track]');
    var thumbsBox = gallery.querySelector('[data-gallery-thumbs]');
    if (!track || !thumbsBox) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(thumbsBox.querySelectorAll('[data-gallery-thumb]'));
    // One image is not a gallery. Liquid already withholds the thumbnail strip
    // in that case, so this is the belt to that braces.
    if (slides.length < 2 || thumbs.length < 2) return;

    // -1, not 0: the first setActive() has to be allowed to run its side effects
    // even though the markup ships with slide 0 already marked.
    var active = -1;

    // Measured against the first slide rather than the track, for the same
    // reason the values rail does it: the first slide's own offsetLeft is not
    // necessarily zero.
    function offsetOf(i) {
      return slides[i].offsetLeft - slides[0].offsetLeft;
    }

    // Below 640px the strip is a 68px-wide column that scrolls (see
    // .pdp-gallery__thumbs in stigma-base.css), so a slide reached by swiping
    // can easily be marked on a thumbnail that is out of view. Scrolled by hand
    // rather than with scrollIntoView(), which walks up every scrollable
    // ancestor and would drag the page itself around a phone-sized strip.
    // Desktop's strip is a wrapping grid that never overflows, so the guard
    // below is false there and nothing happens.
    function revealThumb(i) {
      if (thumbsBox.scrollHeight <= thumbsBox.clientHeight + 1) return;
      var thumb = thumbs[i];
      var top = thumb.offsetTop - thumbs[0].offsetTop;
      var viewTop = thumbsBox.scrollTop;
      if (top >= viewTop && top + thumb.offsetHeight <= viewTop + thumbsBox.clientHeight) return;
      // Aligned to the top of the strip, not scrolled by the minimum needed to
      // bring the tile into view. The strip carries scroll-snap-type:y proximity
      // and every tile is a snap point, so a minimal scroll lands between two of
      // them and the browser pulls it straight back to the one it came from —
      // measured: revealing the fifth of seven tiles asked for scrollTop 32 and
      // got 0 back. Each tile's own offset is a snap point, so this sticks.
      thumbsBox.scrollTop = Math.min(top, thumbsBox.scrollHeight - thumbsBox.clientHeight);
    }

    // Guarded on the index so this is safe to call from the track's scroll
    // event, which fires many times per swipe.
    function setActive(i) {
      if (i === active) return;
      active = i;
      thumbs.forEach(function (thumb, n) {
        thumb.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      revealThumb(i);
    }

    // Nearest slide to the track's left edge wins, so a half-swipe marks the
    // slide the reader is looking at rather than the one they left.
    function nearest() {
      var best = 0, bestGap = Infinity;
      slides.forEach(function (slide, i) {
        var gap = Math.abs(offsetOf(i) - track.scrollLeft);
        if (gap < bestGap) { bestGap = gap; best = i; }
      });
      return best;
    }

    // Positioned instantly rather than with behavior:'smooth', and the choice is
    // load-bearing: scroll-snap-type:x mandatory and a programmatic smooth
    // scroll fight each other in Chrome — the animation gets re-snapped to a
    // slide it passes through and stops there, so clicking the fourth thumbnail
    // from the first slide can land on the second. Swiping and dragging keep
    // every bit of their native smoothness; only this jump is instant, which is
    // what a thumbnail is expected to do anyway. It also means there is no
    // motion here for prefers-reduced-motion to have an opinion about.
    function show(i) {
      if (i < 0 || i >= slides.length) return;
      track.scrollLeft = offsetOf(i);
      // Not left to the scroll event: clicking the thumbnail for the slide
      // already shown scrolls by zero pixels and fires no scroll event at all.
      setActive(i);
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
    });

    // Arrow keys move along the strip and take the slide with them, which is
    // what a row of buttons that all control one thing has to do to be usable
    // without a mouse — tabbing through every thumbnail to reach the last image
    // is not it. Both axes are accepted because the strip is a row on desktop
    // and a column on a phone. Focus follows the selection so the next press
    // continues from where the last one landed.
    thumbsBox.addEventListener('keydown', function (e) {
      var dir = 0;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
      else return;
      var next = active + dir;
      if (next < 0 || next >= thumbs.length) return;
      e.preventDefault();
      show(next);
      thumbs[next].focus();
    });

    track.addEventListener('scroll', function () { setActive(nearest()); }, { passive: true });
    wireDragScroll(track);

    // A resize changes every slide's width, and the scroll offset it was holding
    // is measured in the old ones — crossing 640px, where the phone layout hands
    // 68px of the row to the thumbnail strip, is enough to leave the track parked
    // between two slides. Re-anchoring on the slide that was showing costs
    // nothing and does not depend on the browser re-snapping on its own.
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (active >= 0) track.scrollLeft = offsetOf(active);
      }, 200);
    });

    setActive(nearest());
  }

  // --- mobile menu ---
  var menuOpener = null;
  function menuPanel() { return document.getElementById('StigmaMenu'); }
  function menuBurger() { return document.querySelector('[data-menu-open]'); }
  function openMenu(opener) {
    var p = menuPanel(); if (!p) return;
    menuOpener = opener || null;
    p.classList.add('open');
    document.body.classList.add('no-scroll');
    var b = menuBurger(); if (b) b.setAttribute('aria-expanded', 'true');
    var close = p.querySelector('[data-menu-close]'); if (close) close.focus();
  }
  function closeMenu(restoreFocus) {
    var p = menuPanel();
    if (!p || !p.classList.contains('open')) return;
    p.classList.remove('open');
    document.body.classList.remove('no-scroll');
    var b = menuBurger(); if (b) b.setAttribute('aria-expanded', 'false');
    if (restoreFocus && menuOpener) menuOpener.focus();
    menuOpener = null;
  }
  function initMenu() {
    if (!menuPanel()) return;
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-menu-open]');
      if (opener) { e.preventDefault(); openMenu(opener); return; }
      if (e.target.closest('[data-menu-close]')) { e.preventDefault(); closeMenu(true); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closeMenu(true);
    });
    // The cart button also lives inside the menu. Capture phase on purpose: a cart
    // app (Rebuy Smart Cart is installed on this store) can intercept the click
    // before it bubbles, so the menu must not depend on our own openCart running.
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) closeMenu(false);
    }, true);
  }

  // --- cart ---
  function fmtMoney(cents, format) {
    var amt = (cents / 100).toFixed(2);
    var noDec = Math.round(cents / 100).toString();
    if (!format) return '$' + amt;
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, amt)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amt.replace('.', ','));
  }
  function drawer() { return document.getElementById('StigmaCartDrawer'); }
  function mask() { return document.getElementById('StigmaCartMask'); }
  function openCart() {
    var d = drawer(), m = mask(); if (!d) return;
    d.classList.add('open'); if (m) m.classList.add('open');
    document.body.classList.add('no-scroll');
  }
  function closeCart() {
    var d = drawer(), m = mask(); if (!d) return;
    d.classList.remove('open'); if (m) m.classList.remove('open');
    document.body.classList.remove('no-scroll');
  }
  function toast(msg) {
    var t = document.getElementById('StigmaToast');
    if (!t) { t = document.createElement('div'); t.id = 'StigmaToast'; t.className = 'stigma-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('show'); }, 3800);
  }
  function renderCart(cart) {
    // The count badge is in the header, not in the drawer, so it has to be
    // written before the drawer check below. It used to sit after it, which was
    // harmless while the drawer always existed — but the drawer is no longer
    // rendered (see layout/theme.liquid), drawer() is null, and the early return
    // froze both header counts at 0 for the whole session.
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var d = drawer(); if (!d) return;
    var fmt = d.getAttribute('data-money-format') || '';
    var sub = d.querySelector('[data-cart-subtotal]');
    if (sub) sub.textContent = fmtMoney(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price, fmt);
    var wrap = d.querySelector('[data-cart-items]');
    var empty = d.querySelector('[data-cart-empty]');
    if (!wrap) return;
    if (!cart.items.length) {
      wrap.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';
    wrap.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image + '" alt="" style="max-height:92%;max-width:92%;object-fit:contain;">' : '';
      return '' +
        '<div class="cart-line" data-line-key="' + it.key + '" style="padding:20px 28px;display:flex;gap:14px;">' +
          '<div style="width:64px;height:84px;background:var(--ink-2);display:flex;align-items:center;justify-content:center;flex-shrink:0;overflow:hidden;">' + img + '</div>' +
          '<div style="flex:1;min-width:0;color:var(--bone);">' +
            '<div style="font-size:11px;letter-spacing:0.22em;text-transform:uppercase;font-weight:600;">' + it.product_title + '</div>' +
            '<div style="font-size:11px;color:var(--ash);margin-top:2px;letter-spacing:0.04em;">' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '') + '</div>' +
            '<div style="margin-top:10px;display:flex;align-items:center;justify-content:space-between;">' +
              '<div style="display:inline-flex;background:rgba(249,247,242,0.07);">' +
                /* Not all:unset here — that would reset width/height/margin too, and an
                   inline reset (however it's spelled) always beats the external
                   .cart-qty-btn rule that sizes these buttons responsively (base 26x26,
                   44x44 on touch widths). This lists only the UA-button properties that
                   actually need clearing. */
                '<button type="button" class="cart-qty-btn" data-cart-minus aria-label="Decrease" style="border:none;background:none;padding:0;font:inherit;appearance:none;-webkit-appearance:none;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;font-size:14px;font-weight:600;color:var(--bone);">−</button>' +
                '<span style="width:32px;height:26px;display:inline-flex;align-items:center;justify-content:center;font-size:12px;font-weight:600;background:rgba(249,247,242,0.10);color:var(--bone);">' + it.quantity + '</span>' +
                '<button type="button" class="cart-qty-btn" data-cart-plus aria-label="Increase" style="border:none;background:none;padding:0;font:inherit;appearance:none;-webkit-appearance:none;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;font-size:14px;font-weight:600;color:var(--bone);">+</button>' +
              '</div>' +
              '<div style="font-family:var(--font-sans);font-weight:900;font-size:22px;color:var(--bone);letter-spacing:-0.01em;">' + fmtMoney(it.final_line_price, fmt) + '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');
  }
  function refreshCart(open) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (open) openCart(); return cart; })
      .catch(function () {});
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; });
  }
  function initCart() {
    // Open / close
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
      if (e.target.closest('[data-cart-close]') || e.target.id === 'StigmaCartMask') { e.preventDefault(); closeCart(); }
    });
    // Add to cart (any form marked data-cart-form).
    //
    // Capture phase, for the same reason the menu's cart button uses it: an
    // installed cart app adds its own submit listener and calls
    // stopPropagation() on the event WITHOUT calling preventDefault(). A
    // bubble-phase listener here never ran, so the browser fell through to the
    // native POST and every "Add" on a product card did a full page load to
    // /cart instead of opening the drawer. Capture runs before the app can stop
    // the event, so preventDefault() is guaranteed to land.
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-cart-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('disabled', 'disabled');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) { toast((res.data && (res.data.description || res.data.message)) || 'Could not add to cart.'); return; }
          return refreshCart(true);
        })
        .catch(function () { toast('Could not add to cart. Please try again.'); })
        .then(function () { if (btn) btn.removeAttribute('disabled'); });
    }, true);
    // Qty steppers (delegated)
    document.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line-key]'); if (!line) return;
      var key = line.getAttribute('data-line-key');
      var qtyEl = line.querySelector('span'); var cur = parseInt(qtyEl ? qtyEl.textContent : '0', 10) || 0;
      if (e.target.closest('[data-cart-minus]')) changeLine(key, Math.max(0, cur - 1));
      else if (e.target.closest('[data-cart-plus]')) changeLine(key, cur + 1);
    });
    refreshCart(false);
  }

  // --- marquee ---
  // The track has to be at least twice the width of its container, otherwise the
  // tail of the last copy scrolls into empty space before the first one wraps.
  // Duplicating the content once is not enough when there are only a few logos,
  // so clone the group until it overflows, then translate by exactly one group.
  function buildMarquee(track) {
    var group = track.querySelector('[data-marquee-group]');
    if (!group) {
      group = document.createElement('div');
      group.setAttribute('data-marquee-group', '');
      group.className = 'marquee-group';
      while (track.firstChild) group.appendChild(track.firstChild);
      track.appendChild(group);
    }
    // Drop previous clones before re-measuring (viewport may have changed).
    while (track.children.length > 1) track.removeChild(track.lastChild);

    var groupWidth = group.getBoundingClientRect().width;
    if (!groupWidth) return;
    var container = track.parentElement || track;
    var needed = Math.ceil((container.getBoundingClientRect().width * 2) / groupWidth);
    var copies = Math.max(2, needed);
    for (var i = 1; i < copies; i++) track.appendChild(group.cloneNode(true));
    track.style.setProperty('--marquee-copies', copies);
    // Hold a constant pixel speed regardless of how many copies we ended up with.
    track.style.setProperty('--marquee-duration', (groupWidth / 60).toFixed(2) + 's');
  }

  function initMarquee() {
    var tracks = document.querySelectorAll('[data-marquee]');
    if (!tracks.length) return;
    tracks.forEach(buildMarquee);
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      // Re-query rather than closing over `tracks`: the values rail hands its
      // own track in and out of marquee mode at 640px (initValuesRail's
      // enable()/disable()), and data-marquee IS the mode flag — enable()
      // removes it, disable() restores it and calls buildMarquee() itself. A
      // NodeList captured once at init cannot see that later change. Loading
      // desktop-first and then narrowing past 640px used to leave this
      // closure holding a list that still had the values track in it, so
      // 200ms after enable() had already stripped data-marquee and unwrapped
      // the cards, this handler fired and re-cloned it anyway — eight cards
      // laid out against four dots, with no console error to say why. The
      // mirror case is just as real: after a phone->desktop crossing, a
      // captured list *excludes* the values track forever, so it would never
      // re-measure its copy count on a later desktop resize either.
      resizeTimer = setTimeout(function () {
        document.querySelectorAll('[data-marquee]').forEach(buildMarquee);
      }, 200);
    });
  }

  // --- product form ---
  function initProductForm() {
    var fmtEl = document.getElementById('StigmaCartDrawer');
    var fmt = fmtEl ? fmtEl.getAttribute('data-money-format') : '';
    // Apply one variant's data to the price block and the Add button.
    // `src` is anything carrying data-price / data-compare-at / data-available —
    // a pack chip today, and whatever replaces it later.
    function applyVariant(src, scope) {
      var cents = parseInt(src.getAttribute('data-price'), 10);
      // div[...] on purpose: the picker's own elements carry the same attributes
      // and render before the price block, so a bare [data-price] would match one
      // of them first.
      var priceEl = scope.querySelector('div[data-price]');
      if (priceEl && !isNaN(cents)) priceEl.textContent = fmtMoney(cents, fmt);

      // Strike-through original only while it is genuinely above the sale price.
      var cmp = parseInt(src.getAttribute('data-compare-at'), 10);
      var cmpEl = scope.querySelector('div[data-compare-at]');
      if (cmpEl) {
        if (!isNaN(cmp) && !isNaN(cents) && cmp > cents) {
          cmpEl.textContent = fmtMoney(cmp, fmt);
          cmpEl.style.display = '';
        } else {
          cmpEl.textContent = '';
          cmpEl.style.display = 'none';
        }
      }

      // A sold-out pack must not leave an enabled Add to Cart behind.
      var avail = src.getAttribute('data-available') !== 'false';
      var btn = scope.querySelector('[data-add-btn]');
      if (btn) {
        var labelEl = btn.querySelector('[data-add-label]');
        var arrow = btn.querySelector('.arr');
        btn.disabled = !avail;
        btn.style.opacity = avail ? '' : '0.5';
        if (labelEl) labelEl.textContent = avail ? (btn.getAttribute('data-label') || '') : (btn.getAttribute('data-soldout-label') || '');
        if (arrow) arrow.style.display = avail ? '' : 'none';
      }
    }

    // Pack chips. Delegated so the picker survives a section re-render in the
    // theme editor without needing to rebind.
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-pack]');
      if (!chip) return;
      var scope = chip.closest('form') || document;
      var group = chip.closest('.pack-picker');
      if (group) {
        group.querySelectorAll('[data-pack]').forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-selected', on);
          c.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      }
      var input = scope.querySelector('[data-pack-input]');
      if (input) {
        input.value = chip.getAttribute('data-id');
        // Setting .value fires nothing. App blocks inside this form (Loop's
        // subscription widget) listen for change on the id input and read
        // ?variant= to pick the selling plans for the chosen pack.
        input.dispatchEvent(new Event('change', { bubbles: true }));
        var url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState(history.state, '', url);
      }
      applyVariant(chip, scope);
    });

    // Arrow keys move between chips, which is what role="radio" promises.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var chip = e.target.closest('[data-pack]');
      if (!chip) return;
      var chips = Array.prototype.slice.call(chip.closest('.pack-picker').querySelectorAll('[data-pack]'));
      var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
      var next = chips[(chips.indexOf(chip) + step + chips.length) % chips.length];
      e.preventDefault();
      next.focus();
      next.click();
    });
    document.addEventListener('click', function (e) {
      var wrap = e.target.closest('[data-qty-minus],[data-qty-plus]'); if (!wrap) return;
      var box = wrap.parentNode; var input = box.querySelector('[data-qty-input]'); if (!input) return;
      var cur = parseInt(input.value, 10) || 1;
      if (e.target.closest('[data-qty-minus]')) input.value = Math.max(1, cur - 1);
      else input.value = cur + 1;
    });
  }

  // Shared rail controls: prev/next stepping, disabling at each end, and a nav
  // that stays hidden while the row still fits. Used by the phone product rows
  // and by the values rail on the about page — one behaviour, so one copy.
  // Returns its own sync() so a caller that changes the rail underneath it (the
  // values rail does, when the viewport crosses 640px) can re-run the checks.
  function wireRail(rail, nav) {
    var prev = nav.querySelector('[data-pgrid-prev]');
    var next = nav.querySelector('[data-pgrid-next]');
    if (!prev || !next) return null;

    function overflowing() {
      // A track wider than its box is only *scrollable* if it is actually a
      // scroll container. The values rail is a marquee above 640px — wider
      // than its parent, but clipped rather than scrolled — so width alone
      // would show arrows that cannot move anything.
      if (getComputedStyle(rail).overflowX === 'visible') return false;
      return rail.scrollWidth - rail.clientWidth > 2;
    }

    function sync() {
      if (!overflowing()) { nav.hidden = true; return; }
      nav.hidden = false;
      // A 1px tolerance: fractional scroll positions mean scrollLeft rarely
      // lands exactly on 0 or on the maximum.
      var max = rail.scrollWidth - rail.clientWidth;
      prev.disabled = rail.scrollLeft <= 1;
      next.disabled = rail.scrollLeft >= max - 1;
    }

    function step(dir) {
      // Scroll by one tile plus its gap, read off the DOM rather than
      // hardcoded, so the flex-basis can change in CSS without touching this.
      var first = rail.firstElementChild;
      var by = first ? first.getBoundingClientRect().width + 14 : rail.clientWidth * 0.7;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      rail.scrollBy({ left: dir * by, behavior: reduce ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    // Tiles are lazy-loaded, so scrollWidth is not final at DOMContentLoaded.
    if (window.ResizeObserver) new ResizeObserver(sync).observe(rail);
    sync();
    return sync;
  }

  // Mouse-drag scrolling for a native horizontal scroll container. Two call sites
  // — the values rail on the about page and the PDP gallery track — so one copy
  // lives here. Returns a handle whose teardown() aborts a drag in progress, for
  // a caller that changes the rail underneath it mid-gesture (the values rail
  // does, when the viewport crosses 640px).
  function wireDragScroll(rail) {
    // Touch already scrolls the rail natively, and the browser gives that for
    // free: momentum, rubber-banding at the ends, all of it. A JS reimplementation
    // of dragging would only lose fidelity against that — so touch is left alone
    // entirely. A mouse gets none of that native scrolling, though, and a mouse
    // cannot move a scroll container at all without either a visible scrollbar or
    // this. So drag is wired for pointerType 'mouse' only; every other pointer
    // type (touch, pen) returns immediately and never sees dragging: true.
    //
    // Drag state lives here, one set per rail, so a caller that pulls the rail
    // out from under a live gesture can reach teardown() too — see below.
    var dragging = false;
    var dragStartX = 0;
    var dragStartScroll = 0;
    var dragMoved = 0;
    var dragPointerId = null;

    var suppressTimer = null;

    function suppressClick(e) {
      e.preventDefault();
      e.stopPropagation();
      disarmClickSuppressor();
    }

    // Armed after a drag, disarmed the moment it does its job. The timeout is
    // the safety net: a release that produces no click at all — off the end of
    // the document, or a button the browser answers with auxclick instead —
    // would otherwise leave this listener sitting on document in the capture
    // phase, and the next genuine click anywhere on the page would be the one
    // it ate. 300ms is far longer than the gap between pointerup and its click.
    function armClickSuppressor() {
      disarmClickSuppressor();
      document.addEventListener('click', suppressClick, { capture: true });
      suppressTimer = setTimeout(disarmClickSuppressor, 300);
    }

    function disarmClickSuppressor() {
      if (suppressTimer !== null) {
        clearTimeout(suppressTimer);
        suppressTimer = null;
      }
      document.removeEventListener('click', suppressClick, { capture: true });
    }

    // Clears the drag flag, the grabbing cursor, any pointer capture, and hands
    // scroll-snap-type back to the stylesheet so it can settle the rail onto
    // the nearest card. Shared by pointercancel and by the returned teardown();
    // neither is followed by a click, so neither arms the click suppressor —
    // only pointerup's own handler decides about that, once, after calling in
    // here for the rest of the cleanup.
    function teardownDrag() {
      if (!dragging) return;
      dragging = false;
      rail.classList.remove('is-dragging');
      rail.style.removeProperty('scroll-snap-type');
      if (rail.releasePointerCapture && dragPointerId !== null) {
        try { rail.releasePointerCapture(dragPointerId); } catch (err) {}
      }
      dragPointerId = null;
    }

    function onPointerDown(e) {
      // Any press clears a suppressor still armed from a previous drag, so a
      // stale one can never outlive the gesture that armed it.
      disarmClickSuppressor();
      // Primary button only. A secondary or middle press would otherwise start
      // a real drag — scrolling the rail while the context menu opens — and
      // then release without ever producing the click the suppressor waits for.
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true;
      dragMoved = 0;
      dragStartX = e.clientX;
      dragStartScroll = rail.scrollLeft;
      dragPointerId = e.pointerId;
      // scroll-snap-type fights a drag: a snap point mid-drag pulls the rail
      // back toward itself instead of following the pointer. Set as an inline
      // style so it outranks the stylesheet's scroll-snap-type:x mandatory for
      // as long as the drag lasts; removed on release so that rule takes back
      // over and settles the rail onto the nearest card, same as a swipe would.
      rail.style.scrollSnapType = 'none';
      rail.classList.add('is-dragging');
      if (rail.setPointerCapture) rail.setPointerCapture(e.pointerId);
    }

    function onPointerMove(e) {
      if (!dragging) return;
      var dx = e.clientX - dragStartX;
      if (Math.abs(dx) > dragMoved) dragMoved = Math.abs(dx);
      rail.scrollLeft = dragStartScroll - dx;
    }

    function onPointerUp() {
      if (!dragging) return;
      var moved = dragMoved;
      teardownDrag();
      // A real drag ends with a click, fired after pointerup. onPointerDown
      // above already calls rail.setPointerCapture() when it's available,
      // and once a pointer is captured, the browser retargets that eventual
      // click to the CAPTURING element — the rail — no matter where the
      // pointer actually is at release. Confirmed directly against this
      // page: dragging from the rail and releasing over the "next" arrow
      // still produced a click whose target was the rail, never the arrow.
      // So the arrows and the dots were never actually at risk from this
      // click; capture already keeps it away from them on its own.
      //
      // What this listener actually guards against is narrower but still
      // real: that retargeted click landing on the rail itself and
      // continuing to bubble past it (to document, to whatever else is
      // listening further up the tree), and — more importantly — the same
      // problem on any path where setPointerCapture isn't available.
      // That call sits behind an `if (rail.setPointerCapture)` guard for
      // exactly that reason: without it, a real drag-then-release lands on
      // whatever element the pointer is actually over, arrow or dot
      // included, and this suppressor is the only thing standing between
      // that and the control firing. The capturing listener eats the click
      // before it reaches anything, on either path — capture phase runs
      // before the target's own bubble-phase handler, so stopPropagation
      // here stops it regardless of which of the two produced it. A press
      // that never crossed the threshold is a plain click, not a drag, and
      // moved <= 5 leaves it alone.
      //
      // pointercancel is not routed here on purpose: a cancelled gesture is
      // never followed by a click at all (that is what cancelling means), so
      // a suppressor armed on that path could only ever catch an innocent,
      // unrelated click somewhere else on the page later — pointercancel
      // goes straight to teardownDrag() below instead.
      if (moved > 5) {
        armClickSuppressor();
      }
    }

    rail.addEventListener('pointerdown', onPointerDown);
    rail.addEventListener('pointermove', onPointerMove);
    rail.addEventListener('pointerup', onPointerUp);
    rail.addEventListener('pointercancel', teardownDrag);

    return { teardown: teardownDrag };
  }

  // Product rows scroll horizontally on phones. The scrolling itself is CSS —
  // this only adds the arrows, and only once a row actually overflows, so a row
  // that already fits never shows controls that cannot move it.
  function initProductRails() {
    var rails = document.querySelectorAll('[data-pgrid-rail]');
    Array.prototype.forEach.call(rails, function (rail) {
      var nav = rail.parentNode.querySelector('[data-pgrid-nav]');
      if (!nav) return;
      wireRail(rail, nav);
    });
  }

  // Lab-list nutrition panels. The markup ships `open` so the panel is there
  // with no JS, which is what desktop wants and what every non-phone viewport
  // keeps. On a phone the panel is ~570px of reference material in the middle of
  // the document list, so it starts folded. CSS cannot close a <details>, hence
  // this — the toggle itself is native and needs no help.
  function initLabPanels() {
    var panels = document.querySelectorAll('.lab-list__facts');
    if (!panels.length) return;
    var phone = window.matchMedia('(max-width: 640px)');

    function sync() {
      panels.forEach(function (el) {
        // Leave anything the visitor has touched alone until the breakpoint
        // itself changes, so a resize does not undo their click.
        if (el.dataset.userToggled === '1') return;
        var open = !phone.matches;
        el.dataset.progOpen = open ? '1' : '0';
        el.open = open;
      });
    }

    panels.forEach(function (el) {
      // `toggle` fires for our own writes too, and it fires in a later task, so
      // the two cases are told apart by state rather than by a flag: if the
      // element ended up where this script put it, the script put it there.
      el.addEventListener('toggle', function () {
        if (el.dataset.progOpen === (el.open ? '1' : '0')) return;
        el.dataset.userToggled = '1';
      });
    });

    sync();
    // Crossing the breakpoint is a new context: forget the earlier clicks.
    var onChange = function () {
      panels.forEach(function (el) { delete el.dataset.userToggled; });
      sync();
    };
    if (phone.addEventListener) phone.addEventListener('change', onChange);
    else phone.addListener(onChange);
  }

  // --- values rail (about page) ---
  // The value cards share the press marquee's markup. Right on a desktop,
  // unusable on a phone: a 460px card on a 390px screen, sliding past while you
  // try to read it. Below 640px the track stops being a marquee and becomes the
  // same snap rail the product rows use.
  //
  // This cannot be CSS alone. buildMarquee() moves the cards into a wrapper and
  // clones the wrapper until it overflows, and those clones would read as
  // phantom cards in a rail that is supposed to have four of them and an end.
  function initValuesRail() {
    var section = document.querySelector('[data-values-rail]');
    if (!section) return;
    var rail = section.querySelector('[data-values-track]');
    var nav = section.querySelector('[data-values-nav]');
    var dotsBox = section.querySelector('[data-values-dots]');
    if (!rail || !nav || !dotsBox) return;

    var phone = window.matchMedia('(max-width:640px)');
    var cards = [];
    var syncRail = null;
    var wired = false;
    var dragCtl = null;

    // Undo buildMarquee(): drop the clones, then lift the cards out of the group
    // wrapper so they are direct children of the track again. Needed on a resize
    // from desktop down, where the marquee has already been built.
    function unwrapMarquee() {
      var group = rail.querySelector('[data-marquee-group]');
      if (!group) return;
      while (rail.children.length > 1) rail.removeChild(rail.lastChild);
      while (group.firstChild) rail.insertBefore(group.firstChild, group);
      rail.removeChild(group);
      rail.style.removeProperty('--marquee-copies');
      rail.style.removeProperty('--marquee-duration');
    }

    // Measured against the first card, not the track, because the track carries
    // a gutter of scroll padding — the first card's own offsetLeft is not zero.
    function offsetOf(card) {
      return card.offsetLeft - (cards.length ? cards[0].offsetLeft : 0);
    }

    function buildDots() {
      dotsBox.innerHTML = '';
      cards.forEach(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'values-rail__dot';
        dot.setAttribute('aria-label', 'Value ' + (i + 1) + ' of ' + cards.length);
        dot.addEventListener('click', function () {
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          rail.scrollTo({ left: offsetOf(card), behavior: reduce ? 'auto' : 'smooth' });
        });
        dotsBox.appendChild(dot);
      });
    }

    // Nearest card to the rail's left edge wins, so a half-swipe still lights
    // the card the reader is looking at rather than the one they left.
    function syncDots() {
      var dots = dotsBox.children;
      var best = 0, bestGap = Infinity;
      cards.forEach(function (card, i) {
        var gap = Math.abs(offsetOf(card) - rail.scrollLeft);
        if (gap < bestGap) { bestGap = gap; best = i; }
      });
      for (var i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-current', i === best ? 'true' : 'false');
      }
    }

    function enable() {
      unwrapMarquee();
      // initMarquee() runs after this one in init(); without the hook it leaves
      // the track alone.
      rail.removeAttribute('data-marquee');
      cards = Array.prototype.slice.call(rail.children);
      buildDots();
      if (!wired) {
        syncRail = wireRail(rail, nav);
        rail.addEventListener('scroll', syncDots, { passive: true });
        dragCtl = wireDragScroll(rail);
        wired = true;
      }
      if (syncRail) syncRail();
      syncDots();
    }

    function disable() {
      rail.scrollLeft = 0;
      rail.setAttribute('data-marquee', '');
      nav.hidden = true;
      // Defensive, not a fix for anything observed: holding the mouse down on
      // the rail and crossing back over 640px mid-drag would otherwise leave
      // the dragging class and the inline scroll-snap-type override stuck on
      // the track forever, since disable() runs here without waiting for the
      // pointerup that would normally clear them. Cheap insurance against
      // that stale state surviving a mode switch, same family as the stale
      // marquee NodeList this file already had to fix once.
      if (dragCtl) dragCtl.teardown();
      buildMarquee(rail);
    }

    if (phone.matches) enable();
    phone.addEventListener('change', function (e) { if (e.matches) enable(); else disable(); });
  }

  // initValuesRail before initMarquee, not after: on a phone it strips the
  // track's data-marquee hook, and initMarquee would otherwise have already
  // cloned the cards by the time it ran.
  function init() { initAgeGate(); initCountdowns(); initCoupons(); initFaq(); initPdpText(); initPdpGallery(); initMenu(); initCart(); initValuesRail(); initMarquee(); initProductForm(); initProductRails(); initLabPanels(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  window.Stigma = Stigma;
})();
